jQuery(function($){
  $('.main-content.product .tab-container h3:first-child').addClass('jw-active');
  
  $('.main-content.product .tab-container a.tablink').click(function(e){
 
    if($(this).parent().hasClass('jw-active')){
      $(this).parent().removeClass('active');
       var tab = $(this).attr("href");
      $(tab).hide();
      $('.main-content.product .tab-container h3').removeClass('jw-active');
    }else{
      $('.main-content.product .tab-container h3').removeClass('jw-active');
      $(this).parent().addClass('jw-active');
    }

   
    //console.log('xxx');
  });

   //console.log('xxx');
});